import { OkThxWordmark } from "@/components/icons/Logo.tsx";
import { pageColumnClasses, screenGutter } from "@/components/layout/contentLayout.tsx";
import { cn } from "@/lib/utils.ts";

/**
 * Where the Android app's sign-in ends (`NATIVE_HTTPS_CALLBACK_PATH`). Chrome's
 * Auth Tab returns this URL to the app without loading it, so a browser lands
 * here only when the link was opened somewhere else. Its `sign_in` handle is
 * useless without the verifier the app holds, so there is nothing to finish.
 */
export const NativeSignInCallback = () => (
  <div
    className={cn(
      "flex flex-col grow-1 items-center justify-center min-h-dvh",
      screenGutter,
      pageColumnClasses["8"],
    )}
  >
    <div className="flex flex-col items-center gap-4 w-full max-w-[520px] py-10 text-center">
      <OkThxWordmark className="w-[136px] h-[31.98px]" />
      <h1 className="text-2xl font-semibold">Sign in from the Okthx app</h1>
      <p className="text-muted-foreground leading-6">
        This link only works inside the Okthx app. Open the app and sign in again.
      </p>
    </div>
  </div>
);
